import React from "react";

const Loader = ( props ) => {

  const type = props.type ?? 'text'
  const label = props.label ?? 'Loading...'
  let loaderContent = ''

  switch ( type ) {
    case 'text':  
      loaderContent = <div className="msync-loader msync-loader--is-style-text"><span className="msync-loader__label">{ label }</span></div>
      break;
    case 'spinner-dual-ring':  
      loaderContent = <div class="msync-loader msync-loader--is-style-dual-ring"><div className="msync-loader__spinner"></div><span className="msync-loader__label msync-visually-hidden">{ label }</span></div>
      break;
    case 'spinner-ring':  
      loaderContent = <div class="msync-loader msync-loader--is-style-ring"><div className="msync-loader__spinner"><div></div><div></div><div></div><div></div></div><span className="msync-loader__label msync-visually-hidden">{ label }</span></div>
      break;
    default:
      loaderContent = <div className="msync-loader msync-loader--is-style-text">{ label }</div>
      break;
  }

  return(
    <>
      { loaderContent }
    </>
  )

}

export default Loader
